import { createSlice } from '@reduxjs/toolkit';
import { ProductsListStateType } from 'src/types/productsList';

const initialState: ProductsListStateType = {
    data: null,
    loading: false,
    error: false,
    allStock: false,
};
export const productsListSlice = createSlice({
    name: 'productsList',
    initialState,
    reducers: {
        getProductsListFetch: (state, action) => {
            state.allStock = action.payload?.allStock;
            state.loading = true;
            state.error = false;
        },
        getProductsListFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        getProductsListFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
        activateProductsFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        activateProductsFetchSuccess: (state, action) => {
            state.loading = false;
        },
        activateProductsFetchFailure: (state, action) => {
            state.loading = false;
            state.error = true;
        },
        deactivateProductsFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        deactivateProductsFetchSuccess: (state, action) => {
            state.loading = false;
        },
        deactivateProductsFetchFailure: (state, action) => {
            state.loading = false;
            state.error = true;
        },
        syncProductsToDcixFetch: (state) => {
            state.loading = true;
            state.error = false;
        },
        syncProductsToDcixFetchSuccess: (state, action) => {
            state.loading = false;
        },
        syncProductsToDcixFetchFailure: (state, action) => {
            state.loading = false;
            state.error = true;
        },
        syncEansToDcixFetch: (state) => {
            state.loading = true;
            state.error = false;
        },
        syncEansToDcixFetchSuccess: (state, action) => {
            state.loading = false;
        },
        syncEansToDcixFetchFailure: (state, action) => {
            state.loading = false;
            state.error = true;
        },
    },
});

export const {
    getProductsListFetch,
    getProductsListFetchSuccess,
    getProductsListFetchFailure,
    activateProductsFetch,
    activateProductsFetchSuccess,
    activateProductsFetchFailure,
    deactivateProductsFetch,
    deactivateProductsFetchSuccess,
    deactivateProductsFetchFailure,
    syncProductsToDcixFetch,
    syncProductsToDcixFetchSuccess,
    syncProductsToDcixFetchFailure,
    syncEansToDcixFetch,
    syncEansToDcixFetchSuccess,
    syncEansToDcixFetchFailure,
} = productsListSlice.actions;

export default productsListSlice.reducer;
